<template>
  <v-container>
    <div
      data-v-fae5bece
      class="v-card__title headline lighten-2 v-card__title--primary"
      style="padding: 0px"
    >
      <div>{{ this.naslov }}</div>

      <button
        id="closeModalBtn"
        @click.prevent="closeModalInModal_izbor_materijala"
        class="v-btn v-btn--flat white"
      >
        <v-icon>close</v-icon>
      </button>
    </div>

    <div data-v-fae5bece class="spacer"></div>

    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs3 pa-2>
          <v-select
            v-model="additiv_group_to_select"
            :items="additiv_group_to_items"
            item-text="name"
            item-value="id"
            :label="grupaNaslov"
            persistent-hint
            return-object
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
            v-on:change="changeAditiveGroup"
            :disabled="!edit"
          ></v-select>
        </v-flex>
        <v-flex xs4 pa-2>
          <v-autocomplete
            v-model="aditiv_select"
            :items="aditiv_items"
            item-text="name"
            item-value="id"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            :label="naslovPreparat"
            required
            persistent-hint
            return-object
            v-on:change="getAllJediniceMereAditiv"
            :disabled="!edit"
          ></v-autocomplete>
        </v-flex>
        <v-flex
          xs1
          pa-2
          style="
            padding-top: 20px !important;
            padding-left: 0px !important;
            padding-top: 20px !important;
          "
          v-if="1===2"
        >
          <v-icon
            slot="activator"
            @click="otvoriSifarnik"
            style="color: #018389; padding-left: 0px; font-weight: bold"
            title="Dodavanje repromaterijala"
            v-if="edit && additiv_group_to_select !== undefined"
            >add</v-icon
          >
        </v-flex>

        <v-flex xs2 pa-2 style="width: 55% !important">
          <v-text-field
            v-model="kolicina"
            label="Količina"
            type="number"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
            v-on:change="preracunajKoncentraciju"
            :disabled="!edit"
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-select
            v-model="jm_select"
            :items="jm_items_dodatak"
            :item-text="getFieldText"
            item-value="id"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            label="JM"
            required
            persistent-hint
            return-object
            v-on:change="preracunajKoncentracijuJM"
            :disabled="!edit"
          ></v-select>
        </v-flex>
        <v-flex xs1 style="padding-left: 20px">
          <v-icon
            slot="activator"
            id="FloatingButton"
            @click="submit_parameter"
            title="Spisak izdatnica"
            >add</v-icon
          >
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs3 pa-2>
          <v-text-field
            v-model="disease"
            :label="naslovBolest"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
            :disabled="!edit"
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="concentration"
            label="Koncentracija"
            type="number"
            suffix="%"
            v-on:change="preracunajKolicinuKoncentracija"
            min="0"
            v-if="vidljivostKoncentracije"
          ></v-text-field>
        </v-flex>
        <v-flex xs3 pa-2>
          <v-text-field
            v-model="concentrationPerHa"
            label="Količina primene"
            type="number"
            :suffix="pomSuffix"
            v-on:change="preracunajKolicinuKolicinaPrimene"
            min="0"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs11 pa-2>
          <v-textarea
            v-model="opis"
            name="input-5-1"
            class="Description"
            label="Opis"
            :disabled="!edit"
          ></v-textarea>
        </v-flex>
        <!-- /.Dodatak Input -->
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 v-if="edit">
          <v-btn :disabled="!valid" @click="submit" class="AppButtonFilled"
            >Sačuvaj</v-btn
          >
          <v-btn @click="clear_modal_init" class="AppButtonOutlined">odustani</v-btn>
        </v-flex>
      </v-layout>
    </v-form>
    <!-- /.addingToTank -->

    <v-dialog
      v-model="dialogNoteIzdatnice"
      scrollable
      content-class="ModalInModal"
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <div
              data-v-fae5bece
              class="v-card__title headline lighten-2 v-card__title--primary"
              style="padding-left: 30px; padding-bottom: 0px"
            >
              <!-- Modal Titles  -->

              <div v-if="this.jm_select !== undefined">
                Izdatnice za izbor - {{ this.selectedArticleName }}
                {{ parseFloat(this.additiveQuantity).toFixed(this.brojDec) }}
                {{ this.jm === "psc" ? "kom" : this.jm }}
              </div>

              <button
                id="closeModalBtn"
                @click.prevent="closeModal"
                class="v-btn v-btn--flat white"
              >
                <v-icon>close</v-icon>
              </button>
            </div>

            <div data-v-fae5bece class="spacer"></div>

            <MyComponentIzdatnice
              @newdata="handleData($event)"
              @close="handleDataClose($event)"
              :articleId="selectedArticlePom"
              :documentId="materialOperationIdPom"
              operation="VINEYARD_ADDITIVE"
              :unitOfMeasureId="jm_selectPom"
              :additiveQuantity="additiveQuantityPom"
              :ID="ID_item"
              :listaMaterijalaMaka="listaMaterijalaMaka_Pom"
              :izabrani_aditiv="izabrani_aditivi"
              :edit="edit"
            ></MyComponentIzdatnice>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogNote_operacije"
      scrollable
      content-class="ModalInModalGrafic"
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <AdditiveComponent
              @close="handleDataCloseOperacije($event)"
              :operationType="operacija"
            ></AdditiveComponent>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <TokenComponent ref="frmtoken" />
  </v-container>
</template>

        <script>
import { readJSON, currencyFormatDE } from "../helpers/Functions";
import TokenComponent from "../components/Token";
import MyComponentIzdatnice from "./AddingNewComponent";

import AdditiveComponent from "../views/AdditiveItemComponentPom.vue";

export default {
  props: [
    "articleId",
    "ID",
    "plaintObject",
    "vineyardOperationExecution",
    "item",
    "edit",
    "operacija_zastite",
  ],
  name: "VineyardOperationMaterialComponent",
  components: {
    TokenComponent,
    MyComponentIzdatnice,

    AdditiveComponent,
  },
  data: () => ({
    valid: true,
    ID_item: 0,
    ID_spraying: 0,
    items_modal_material: [],
    items_modal_material_save: [],
    items_modal_spraying: [],
    items_modal_spraying_save: [],
    // index_izmene: -1,
    materialOperationId: 0,
    materialOperationIdPom: 0,
    selectedArticle: 0,
    selectedArticlePom: 0,
    selectedArticleName: "",
    dialogNoteIzdatnice: false,
    kolicina: undefined,
    brojDec: 0,
    jm: "",
    materialFromWarehouseDocumentItems: [],
    additiveQuantity: 0,
    additiveQuantityPom: 0,
    items_modal: [],
    headers_modal: [
      { text: "Preparat", value: "additive.name" },
      { text: "Bolest", value: "disease" },
      { text: "Koncentracija (%)", value: "concentration" },
      { text: "Količina primene", value: "concentrationPerHa" },
      // { text: "Vode (L)", value: "waterVolume" },
      // { text: "Vode (L/ha)", value: "waterVolumePerHa" },
      { text: "Funkcije", value: "funkcije", sortable: false },
    ],
    jm_items_dodatak: [],
    jm_select: "",
    jm_selectPom: "",
    opis: "",
    additiv_group_to_items: [],
    additiv_group_to_select: undefined,
    aditiv_items: [],
    aditiv_select: "",
    disease: undefined,
    concentration: undefined,
    concentrationPerHa: undefined,
    pheno_phase: undefined,
    // waterVolume: undefined,
    // waterVolumePerHa: undefined,
    edit_item: undefined,
    listaMaterijalaMaka: [],
    listaMaterijalaMaka_Pom: [],
    izabrani_aditivi: [],
    operacija: undefined,
    dialogNote_operacije: false,
    pomSuffix: "",
    pomSuffixId: 0,
    naslov: "Izbor preparata",
    grupaNaslov: "Grupa preparata",
    naslovPreparat: "Preparat",
    naslovBolest: "Bolest",
    vidljivostKoncentracije: true
  }),
  methods: {
    handleDataCloseOperacije: function (e) {
      // this.getAllOperations(e.name);
      this.operacija = undefined;
      this.getAditives(this.additiv_group_to_select.id, e.name);
      this.dialogNote_operacije = false;
    },
    otvoriSifarnik(event) {
      this.operacija = "Vinograd|" + this.additiv_group_to_select.id;
      this.dialogNote_operacije = true;
    },
    preracunajKolicinuKoncentracija(e) {
      e = Number(e);

      if (this.plaintObject !== undefined) {
        if (
              this.plaintObject.waterVolume !== undefined &&
              this.plaintObject.waterVolume !== null
            ){
              if (this.jm_select.mark !== undefined && this.jm_select.mark !== null)
                {
                  if(e > 0){
                    if (this.jm_select.mark === "g" || this.jm_select.mark === "ml")
                      this.kolicina = Math.round(((this.plaintObject.waterVolume * e/100) * 1000) * 100) / 100;
                    else if (this.jm_select.mark === "t") this.kolicina = Math.round(((this.plaintObject.waterVolume * e/100) / 1000) * 100) / 100;
                    else this.kolicina = Math.round((this.plaintObject.waterVolume * e / 100) *100) / 100;

                    this.preracunajKoncentracijuJM(this.jm_select, false);
                    
                  }
                  else(
                    alert("Koncentraija ne može biti manja od nule.")
                  )
                }
            }
      }
    },
    preracunajKolicinuKolicinaPrimene(e) {
      if (this.plaintObject !== undefined) {
        if(this.plaintObject.surface > 0 && this.plaintObject.surface !== undefined && this.plaintObject.surface !== null){
          if (this.jm_select.mark !== undefined && this.jm_select.mark !== null)
                {
                  if(e > 0){
                    if (this.jm_select.mark === "g" || this.jm_select.mark === "ml")
                      this.kolicina = Math.round(((this.plaintObject.surface * e / 10000) * 1000) * 100) / 100;
                    else if (this.jm_select.mark === "t") this.kolicina = Math.round(((this.plaintObject.surface * e / 10000) / 1000) * 100) / 100;
                    else this.kolicina = Math.round((this.plaintObject.surface * e / 10000) *100) / 100;

                    this.preracunajKoncentracijuJM(this.jm_select, true);
                  }
                  else(
                    alert("Koncentraija ne može biti manja od nule.")
                  )
                }
        }
        else
          this.concentrationPerHa = undefined;
      }
    },
    preracunajKoncentraciju(e) {
      if (this.plaintObject !== undefined) {
        let lokKol = 0;
        if (this.jm_select !== undefined) {
          if (this.jm_select.mark === "g" || this.jm_select.mark === "ml")
            lokKol = e / 1000;
          else if (this.jm_select.mark === "t") lokKol = e * 1000;
          else lokKol = e;

          if (
              this.plaintObject.waterVolume !== undefined &&
              this.plaintObject.waterVolume !== null
            ){
              if(this.vidljivostKoncentracije)
                  this.concentration =
                    Math.round(
                      ((Number(lokKol) * 100) / this.plaintObject.waterVolume) * 1000
                    ) / 1000;
            
            }
              else
              {
                this.concentration = undefined;
              }

              if (
              this.plaintObject.surface !== undefined &&
              this.plaintObject.surface !== null
            )
                this.concentrationPerHa =
              Math.round(
                (Number(lokKol) / (this.plaintObject.surface / 10000)) * 1000
              ) / 1000;
              else
                this.concentrationPerHa = undefined;
              

              if (
              this.jm_select.mark === "g" ||
              this.jm_select.mark === "kg" ||
              this.jm_select.mark === "t"
            ) {
              this.pomSuffix = "kg/ha";
              this.pomSuffixId = 30;
            } else {
              this.pomSuffix = "l/ha";
              this.pomSuffixId = 29;
            }
        }
      }
    },
    getFieldText(item) {
      let tekst = item.mark;

      if (item.mark === "psc") tekst = "kom";

      return tekst;
    },
    preracunajKoncentracijuJM(e, obj) {
      

      if (this.plaintObject !== undefined) {
        let lokKol = 0;
        if (e !== undefined) {
          if (e.mark === "g" || e.mark === "ml") lokKol = this.kolicina / 1000;
          else if (e.mark === "t") lokKol = this.kolicina * 1000;
          else lokKol = this.kolicina;

          if (
              this.plaintObject.waterVolume !== undefined &&
              this.plaintObject.waterVolume !== null
            ){
              if(obj === null){
                if(this.vidljivostKoncentracije)
                  this.concentration =
                  Math.round(
                    ((Number(lokKol) * 100) / this.plaintObject.waterVolume) * 1000
                  ) / 1000;
              }
              else if(obj){
                if(this.vidljivostKoncentracije)
                  this.concentration =
                  Math.round(
                    ((Number(lokKol) * 100) / this.plaintObject.waterVolume) * 1000
                  ) / 1000;
              }
            }

            if (
              this.plaintObject.surface !== undefined &&
              this.plaintObject.surface !== null
            ){
              // if(obj === null || obj === undefined){
              //   this.concentrationPerHa =
              //   Math.round(
              //     (Number(lokKol) / (this.plaintObject.surface / 10000)) * 1000
              //   ) / 1000;
              // }
              // else
              //   this.concentrationPerHa = undefined;

              this.concentrationPerHa =
                Math.round(
                  (Number(lokKol) / (this.plaintObject.surface / 10000)) * 1000
                ) / 1000;
            }
            else
              this.concentrationPerHa = undefined;

            if (e.mark === "g" || e.mark === "kg" || e.mark === "t") {
              this.pomSuffix = "kg/ha";
              this.pomSuffixId = 30;
            } else {
              this.pomSuffix = "l/ha";
              this.pomSuffixId = 29;
            }
        }
      }
    },
    popuni_izabrane_aditive(niz) {
      this.izabrani_aditivi = [];

      let index;
      let _this = this;

      if (niz !== undefined)
        niz.forEach(function (element) {
          if (element.materialFromWarehouseDocumentItems !== undefined) {
            if (element.materialFromWarehouseDocumentItems.length > 0)
              index = _this.izabrani_aditivi.findIndex(
                (x) =>
                  x.additive.id === element.additive.id &&
                  x.materialFromWarehouseDocumentItemList[0]
                    .materialOperationId ===
                    element.materialFromWarehouseDocumentItems[0]
                      .materialOperationId &&
                  x.materialFromWarehouseDocumentItemList[0]
                    .warehouseInputOutputItem.id ===
                    element.materialFromWarehouseDocumentItems[0]
                      .warehouseInputOutputItem.id
              );
          } else if (element.materialFromWarehouseDocumentItems.length > 0) {
            index = _this.izabrani_aditivi.findIndex(
              (x) =>
                x.additive.id === element.additive.id &&
                x.materialFromWarehouseDocumentItems[0].materialOperationId ===
                  element.materialFromWarehouseDocumentItems[0]
                    .materialOperationId &&
                x.materialFromWarehouseDocumentItems[0].warehouseInputOutputItem
                  .id ===
                  element.materialFromWarehouseDocumentItems[0]
                    .warehouseInputOutputItem.id
            );
          }

          if (index !== -1) _this.izabrani_aditivi.splice(index, index + 1);
          _this.izabrani_aditivi.push(element);
        });
    },
    changeAditiveGroup(a) {
      this.load = this.load + 1;

      if (this.load > 1) {
        this.selectedArticle = 0;
        this.selectedArticleName = "";
        this.materialOperationId = 0;
        this.kolicina = undefined;
        this.jm_select = undefined;

        this.aditiv_select = undefined;
      }

      if (typeof a !== "undefined") {
        if (a.id === undefined) {
          if (a !== undefined) {
            // this.PreostaloUTanku(a);
            this.getAditives(a);

            //if (this.load > 1)
            // this.aditiv_select = undefined;
          } else if (typeof this.operation_to_select === "undefined") {
            this.operation_to_select = undefined;
          }
        } else {
          this.getAditives(a.id);

          //if (this.load > 1)
          // this.aditiv_select = undefined;
        }
      }
    },
    closeModal() {
      this.dialogNoteIzdatnice = false;

      this.additiveQuantityPom = undefined;
      this.selectedArticlePom = undefined;
      this.materialOperationIdPom = undefined;
      this.jm_selectPom = undefined;

      this.listaMaterijalaMaka_Pom = [];

      if(this.materialFromWarehouseDocumentItems !== undefined && this.materialFromWarehouseDocumentItems !== null)
        if(this.materialFromWarehouseDocumentItems.length === 0)
          alert("Nisu izabrane količine sa izdatnica.")
    },

    closeModalInModal_izbor_materijala() {
      let complex;

      complex = {
        save_material: this.items_modal_material_save,
        show_material: this.items_modal_material,
        save_spraying: this.items_modal_spraying_save,
        show_spraying: this.items_modal_spraying,
      };

      this.$emit("close", complex);
    },
    editItemSpray(item) {
      this.load = 0;

      this.edit_item = item;

      this.opis = item.description;

      this.disease = item.disease;
      if(this.vidljivostKoncentracije)
        this.concentration = item.concentration;

      this.concentrationPerHa = item.concentrationPerHa;
      // this.waterVolume = item.waterVolume;
      // this.waterVolumePerHa = item.waterVolumePerHa;
      this.ID_spraying = item.id;
      // this.index_izmene = this.items_modal.indexOf(item);

      let pronadjiObj = this.PronadjiID_Materijal(item.additive.id);
      this.ID_item = pronadjiObj.id;

      if (pronadjiObj !== undefined) {
        this.additiv_group_to_select = pronadjiObj.additive.additiveGroup;

        this.selectedArticle = pronadjiObj.additive.id;
        this.selectedArticleName = pronadjiObj.additive.name;

        this.kolicina = pronadjiObj.quantity;
        this.jm_select = pronadjiObj.unitOfMeasure;
        this.materialOperationId = pronadjiObj.id;
        this.additiveQuantity = pronadjiObj.quantity;

        let pomStr = pronadjiObj.unitOfMeasure.mark;
        this.jm = pomStr.split("/")[0];

        if (this.jm === "kom") this.brojDec = 0;
        else if (this.jm === "g" || this.jm === "ml") this.brojDec = 1;
        else this.brojDec = 3;
      
        this.materialFromWarehouseDocumentItems = pronadjiObj.materialFromWarehouseDocumentItems;
      }

      this.aditiv_select = item.additive;
      
    },

    deleteItemModal(item) {
      // confirm("Da li ste sigurni da želite obrisati izabrani zapis?") &&
      //   this.deleteSifarnik(item.id);

      if (this.ID !== 0)
        confirm("Da li ste sigurni da želite obrisati izabrani zapis?") &&
          this.deleteSifarnik(item.id);
      else {
        let ind = 0;

        ind = this.items_modal_material.findIndex((x) => x === item);

        if (ind >= 0) {
          this.items_modal_material.splice(ind, 1);
          this.items_modal_material_save.splice(ind, 1);
          this.items_modal_spraying.splice(ind, 1);
          this.items_modal_spraying_save.splice(ind, 1);
        }
      }
    },
    deleteSifarnik(id) {
      let _this = this;

      this.$http
        .delete(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_operation_execution/spraying/" +
            id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          _this.getAllSifarnik();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .delete(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_operation_execution/material/" +
                        id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // let ind1 = 0;
                      // ind1 = _this.items_modal_spraying.findIndex(
                      //   (x) => x.id === id
                      // );

                      // let ind2 = 0;
                      // ind2 = _this.items_modal_material.findIndex(
                      //   (x) =>
                      //     x.additive.id ===
                      //     _this.items_modal_spraying[ind1].additive.id
                      // );

                      _this.getAllSifarnik();
                      // _this.deleteSifarnikMaterijala(
                      //   _this.items_modal_material[ind2].id
                      // );
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllGroups() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/additiv_group/operation/VINEYARD",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log(response.data);

          this.additiv_group_to_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/additiv_group/operation/VINEYARD",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.additiv_group_to_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAditives(a, aditivZaSelektovanje) {
      let url = "";

      url =
        this.globalServiceLocation +
        this.globalPort +
        "/additiv_group/" +
        a +
        "/additives";

      this.$http
        .get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          this.aditiv_items = response.data;

          if (
            aditivZaSelektovanje !== undefined &&
            aditivZaSelektovanje !== null
          ) {
            let ind = this.aditiv_items.findIndex(
              (x) => x.name === aditivZaSelektovanje
            );

            this.aditiv_select = this.aditiv_items[ind];
          }
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(url, {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    })
                    .then((response) => {
                      this.aditiv_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    submit() {
      if (this.$refs.form.validate()) {
        let ind1 = 0;
        ind1 = this.items_modal_material.findIndex(
          (x) => x.additive.id === this.aditiv_select.id
        );

        if (this.ID_item === 0 && ind1 >= 0) {
          alert("Navedeni repromaterijal je već izabran.");
        } else {
          let idAditiva = null;
          if (this.aditiv_select.id !== undefined)
            idAditiva = this.aditiv_select.id;
          else idAditiva = this.aditiv_select.id;

          let pomBool = true;

          if (this.ID !== 0 && this.ID_item === 0) {
            let pronadjiObj = this.items_modal_material.find(
              (item1) => item1.additive.id === idAditiva
            );

            if (pronadjiObj !== undefined) pomBool = false;
          }

          if (!pomBool) alert("Izabrani artikal je već dodat.");
          else if (this.$refs.form.validate()) {
            let complexObject;
            complexObject = {
              id: null,
              additiveGroup: this.additiv_group_to_select,
              additive: this.aditiv_select,
              materialFromWarehouseDocumentItems:
                this.materialFromWarehouseDocumentItems,
              quantity: this.kolicina,
              unitOfMeasure: this.jm_select,
              description: this.opis,
            };

            let complexObjectSpraying;

            let pom_disease = undefined;
            if (this.disease !== undefined) pom_disease = this.disease;

            let pom_concentration = undefined;
            if (this.concentration !== undefined)
              pom_concentration = this.concentration;

            let pom_concentrationPerHa = undefined;
            if (this.concentrationPerHa !== undefined)
              pom_concentrationPerHa = this.concentrationPerHa;

            // let pom_waterVolumePerHa = undefined;
            // if (this.waterVolumePerHa !== undefined)
            //   pom_waterVolumePerHa = this.waterVolumePerHa;

            // let pom_waterVolume = undefined;
            // if (this.waterVolume !== undefined)
            //   pom_waterVolume = this.waterVolume;

            complexObjectSpraying = {
              id: null,
              additive: this.aditiv_select,
              disease: pom_disease,
              concentration: pom_concentration,
              concentrationPerHa: pom_concentrationPerHa,
              concentrationUnitOfMeasure: null,
              // waterVolume: pom_waterVolume,
              // waterVolumePerHa: pom_waterVolumePerHa,
              description: this.opis,
              quantity: this.kolicina,
              unitOfMeasure: this.jm_select,
            };

            let objUnitOfMeasure = null;
            if (this.jm_select !== null)
              objUnitOfMeasure = {
                id: this.jm_select.id,
              };

            let objAdditive = {
              id: idAditiva,
            };

            let complexObjectSave;
            complexObjectSave = {
              id: null,
              additive: objAdditive,
              materialFromWarehouseDocumentItems:
                this.materialFromWarehouseDocumentItems,
              quantity: this.kolicina,
              unitOfMeasure: objUnitOfMeasure,
              description: this.opis,
            };

            let complexObjectSprayingSave;

            complexObjectSprayingSave = {
              id: null,
              additive: objAdditive,
              disease: pom_disease,
              concentration: pom_concentration,
              concentrationPerHa: pom_concentrationPerHa,
              concentrationUnitOfMeasure: {
                id: this.pomSuffixId,
              },
              // waterVolume: pom_waterVolume,
              // waterVolumePerHa: pom_waterVolumePerHa,
              description: this.opis,
            };

            if (this.ID_item !== 0) {
              complexObject.id = this.ID_item;
              complexObjectSave.id = this.ID_item;

              complexObjectSpraying.id = this.ID_spraying;
              complexObjectSprayingSave.id = this.ID_spraying;

              let ind = 0;
              ind = this.items_modal_material.findIndex(
                (x) => x.id === this.ID_item
              );

              let ind_pom = 0;
              ind_pom = this.items_modal_spraying.findIndex(
                (x) => x.id === this.ID_spraying
              );

              if (ind >= 0) {
                this.items_modal_material.splice(ind, 1);
                this.items_modal_material_save.splice(ind, 1);
              }

              if (ind_pom >= 0) {
                this.items_modal_spraying.splice(ind_pom, 1);
                this.items_modal_spraying_save.splice(ind_pom, 1);
              }

              this.items_modal_material.push(complexObject);
              this.items_modal_material_save.push(complexObjectSave);

              this.items_modal_spraying.push(complexObjectSpraying);
              this.items_modal_spraying_save.push(complexObjectSprayingSave);

              this.clear();
            } else {
              this.items_modal_material.push(complexObject);
              this.items_modal_material_save.push(complexObjectSave);

              this.items_modal_spraying.push(complexObjectSpraying);
              this.items_modal_spraying_save.push(complexObjectSprayingSave);

              this.clear();
            }

            if (this.ID !== 0) this.changeSifarnik();
          }
        }
      }
    },
    PronadjiID_Materijal(id) {
      let pronadjiObj = this.items_modal_material.find(
        (item1) => item1.additive.id === id
      );

      return pronadjiObj;
    },
    changeSifarnik() {
      this.vineyardOperationExecution.vineyardOperationMaterials =
        this.items_modal_material_save;
      this.vineyardOperationExecution.vineyardOperationSprayings =
        this.items_modal_spraying_save;

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_operation_execution/update",
          this.vineyardOperationExecution,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.getAllSifarnik();
          this.clear();
        })
        .catch((e) => {
          // // console.log(e.response);
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_operation_execution/update",
                      complexObjectGlobal,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.getAllSifarnik();
                      this.clear();
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllSifarnik() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_operation_execution/" +
            this.ID,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.srediObjekat(response.data);
        })
        .catch((e) => {
          // // console.log(e.response);
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_operation_execution/" +
                        this.ID,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.srediObjekat(response.data);
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllJediniceMereAditiv(a) {
      if (typeof a !== "undefined")
        if (typeof a.id !== "undefined") {
          let ind = 0;
          ind = this.aditiv_items.findIndex((x) => x.id === a.id);

          if (ind >= 0) {
            this.selectedArticle = this.aditiv_items[ind].id;
            this.selectedArticleName = this.aditiv_items[ind].name;
          }
          this.$http
            .get(
              this.globalServiceLocation +
                this.globalPort +
                "/additiv/" +
                a.id +
                "/with_unit",
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization:
                    "Bearer  " + localStorage.getItem("user-token"),
                },
              }
            )
            .then((response) => {
              //// // console.log(response.data);

              this.jm_items_dodatak = response.data.unitOfMeasure;
            })
            .catch((e) => {
              // // console.log(e.response);

              if (!e.response) {
                alert(
                  this.$t("error.message")
                );
              } else {
                if (e.response.status === 401) {
                  this.$refs.frmtoken
                    .osvezavanjeTokena(
                      localStorage.getItem("user-refresh-token")
                    )
                    .then((result) => {
                      // // console.log(result);
                      // // console.log("Novi token - " + localStorage.getItem("user-token"));

                      this.$http
                        .get(
                          this.globalServiceLocation +
                            this.globalPort +
                            "/additiv/" +
                            a.id +
                            "/with_unit",
                          {
                            headers: {
                              "Content-Type": "application/json",
                              Authorization:
                                "Bearer  " + localStorage.getItem("user-token"),
                            },
                          }
                        )
                        .then((response) => {
                          //// // console.log(response.data);

                          this.jm_items_dodatak = response.data.unitOfMeasure;
                        })
                        .catch((e) => {
                          // // console.log(e.response);

                          let pomError = readJSON(e.response.data.message);
                          alert(pomError);
                        });
                    });
                } else {
                  let pomError = readJSON(e.response.data.message);
                  alert(pomError);
                }
              }
            });
        } else {
          let ind = 0;
          ind = this.aditiv_items.findIndex((x) => x.id === a);

          if (ind >= 0) {
            this.selectedArticle = this.aditiv_items[ind].id;
            this.selectedArticleName = this.aditiv_items[ind].name;
          }

          this.$http
            .get(
              this.globalServiceLocation +
                this.globalPort +
                "/additiv/" +
                a +
                "/with_unit",
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization:
                    "Bearer  " + localStorage.getItem("user-token"),
                },
              }
            )
            .then((response) => {
              //// // console.log(response.data);

              this.jm_items_dodatak = response.data.unitOfMeasure;
            })
            .catch((e) => {
              // // console.log(e.response);

              if (!e.response) {
                alert(
                  this.$t("error.message")
                );
              } else {
                if (e.response.status === 401) {
                  this.$refs.frmtoken
                    .osvezavanjeTokena(
                      localStorage.getItem("user-refresh-token")
                    )
                    .then((result) => {
                      // // console.log(result);
                      // // console.log("Novi token - " + localStorage.getItem("user-token"));

                      this.$http
                        .get(
                          this.globalServiceLocation +
                            this.globalPort +
                            "/additiv/" +
                            a +
                            "/with_unit",
                          {
                            headers: {
                              "Content-Type": "application/json",
                              Authorization:
                                "Bearer  " + localStorage.getItem("user-token"),
                            },
                          }
                        )
                        .then((response) => {
                          //// // console.log(response.data);

                          this.jm_items_dodatak = response.data.unitOfMeasure;
                        })
                        .catch((e) => {
                          // // console.log(e.response);

                          let pomError = readJSON(e.response.data.message);
                          alert(pomError);
                        });
                    });
                } else {
                  let pomError = readJSON(e.response.data.message);
                  alert(pomError);
                }
              }
            });
        }
    },
    proveriAditiv(aditiv) {
      let lokal = false;

      let index = this.items_modal_material.findIndex(
        (x) => x.additive.id === aditiv.id
      );

      if (index >= 0) lokal = true;

      return lokal;
    },
    submit_parameter(e) {
      if (this.ID > 0 && this.ID_aditiv === 0)
        alert(
          "Pre izbora materijala sa izdatnica, morate snimiti repromaterijal."
        );
      if (
        this.additiv_group_to_select === undefined ||
        this.additiv_group_to_select === ""
      )
        alert("Grupa repromaterijala mora biti unešena.");
      else if (this.aditiv_select === undefined || this.aditiv_select === "")
        alert("Repromaterijal mora biti unešen.");
      else if (this.kolicina > 0 && this.jm_select !== undefined) {
        e.preventDefault();
        // this.materialFromWarehouseDocumentItems = [];

        this.listaMaterijalaMaka_Pom = this.listaMaterijalaMaka;

        let niz = [];
        let _this = this;

        this.items_modal_material.forEach(function (e) {
          if (e.additive.id === _this.aditiv_select.id) niz.push(e);
        });

        this.popuni_izabrane_aditive(niz);

        this.additiveQuantity = this.kolicina;

        this.additiveQuantityPom = this.kolicina;
        this.selectedArticlePom = this.selectedArticle;
        this.materialOperationIdPom = this.materialOperationId;
        this.jm_selectPom = this.jm_select;

        this.dialogNoteIzdatnice = true;

        if (this.jm_select.mark !== undefined) {
          let pomStr = this.jm_select.mark;
          this.jm = pomStr.split("/")[0];
        }

        if (this.jm === "kom") this.brojDec = 0;
        else if (this.jm === "g" || this.jm === "ml") this.brojDec = 1;
        else this.brojDec = 3;
      } else alert("Količina i jedinica mere moraju biti unete.");
    },
    handleData: function (e) {
      this.materialFromWarehouseDocumentItems = e;

      this.listaMaterijalaMaka_Pom = [];

      this.getAllSifarnik();

      this.additiveQuantityPom = undefined;
      this.selectedArticlePom = undefined;
      this.materialOperationIdPom = undefined;
      this.jm_selectPom = undefined;

      this.dialogNoteIzdatnice = false;
    },
    handleDataClose: function (e) {
      this.listaMaterijalaMaka_Pom = [];

      this.getAllSifarnik();

      this.additiveQuantityPom = undefined;
      this.selectedArticlePom = undefined;
      this.materialOperationIdPom = undefined;
      this.jm_selectPom = undefined;

      this.dialogNoteIzdatnice = e;

      if(this.materialFromWarehouseDocumentItems !== undefined && this.materialFromWarehouseDocumentItems !== null)
        if(this.materialFromWarehouseDocumentItems.length === 0)
          alert("Nisu izabrane količine sa izdatnica.")
    },

    srediObjekat(val) {
      this.items_modal_material = [];
      this.items_modal_material_save = [];

      this.items_modal_spraying = [];
      this.items_modal_spraying_save = [];

      let newArray = val.vineyardOperationMaterials;
      let newArraySpraying = val.vineyardOperationSprayings;

      let _this = this;

      this.listaMaterijalaMaka = [];
        

      newArray.forEach(function (e) {
        if (typeof e === "object") {
          let complexObject;
          complexObject = {
            id: e.id,
            additive: e.additive,
            materialFromWarehouseDocumentItems:
              e.materialFromWarehouseDocumentItems,
            quantity: e.quantity,
            unitOfMeasure: e.unitOfMeasure,
            description: e.description,
          };

          let pomAdd = e.additive;

          e.materialFromWarehouseDocumentItems.forEach(function (elem) {
            elem.additive = pomAdd;
            _this.listaMaterijalaMaka.push(elem);
          });

          let objUnitOfMeasure = null;
          if (e.unitOfMeasure !== null)
            objUnitOfMeasure = {
              id: e.unitOfMeasure.id,
            };

          let complexObjectSave;
          complexObjectSave = {
            id: e.id,
            additive: {
              id: e.additive.id,
            },
            materialFromWarehouseDocumentItems:
              e.materialFromWarehouseDocumentItems,
            quantity: e.quantity,
            unitOfMeasure: objUnitOfMeasure,
            description: e.description,
          };

          _this.items_modal_material.push(complexObject);
          _this.items_modal_material_save.push(complexObjectSave);
        }
      });

      newArraySpraying.forEach(function (e) {
        if (typeof e === "object") {
          let pronadjiObj = _this.items_modal_material.find(
            (item1) => item1.additive.id === e.additive.id
          );

          let complexObject;
          complexObject = {
            id: e.id,
            additive: e.additive,
            disease: e.disease,
            concentration: e.concentration,
            concentrationPerHa: e.concentrationPerHa,
            concentrationUnitOfMeasure: e.concentrationUnitOfMeasure,
            // waterVolume: e.waterVolume,
            // waterVolumePerHa: e.waterVolumePerHa,
            description: e.description,
            quantity: pronadjiObj.quantity,
            unitOfMeasure: pronadjiObj.unitOfMeasure,
          };

          let objConcentrationUnitOfMeasure = null;
          if (e.concentrationUnitOfMeasure !== null)
            objConcentrationUnitOfMeasure = {
              id: e.concentrationUnitOfMeasure.id,
            };

          let complexObjectSave;
          complexObjectSave = {
            id: e.id,
            additive: e.additive,
            disease: e.disease,
            concentration: e.concentration,
            concentrationPerHa: e.concentrationPerHa,
            concentrationUnitOfMeasure: objConcentrationUnitOfMeasure,
            // waterVolume: e.waterVolume,
            // waterVolumePerHa: e.waterVolumePerHa,
            description: e.description,
          };

          _this.items_modal_spraying.push(complexObject);
          _this.items_modal_spraying_save.push(complexObjectSave);
        }
      });
    },
    clear_modal_init() {
      this.clear();

      this.materialFromWarehouseDocumentItems = [];
    },
    clear() {
      // this.index_izmene = -1;
      this.$refs.form.reset();
      this.ID_item = 0;
      // alert('ocisti modal')

      // alert(this.ID);

      this.materialOperationId = 0;
      this.selectedArticle = 0;
      this.selectedArticleName = "";

      this.materialFromWarehouseDocumentItems = [];

      this.edit_item = undefined;

      this.izabrani_aditivi = [];
    },
  },
  watch: {
    dateModal(val) {
      this.dateFormattedModal = this.formatDate1(this.dateModal);
    },
    articleId: function (val) {
      // this.clear();
    },
    ID: function (val) {
      if (val !== undefined && val !== 0) this.getAllGroups();
    },
    vineyardOperationExecution: function (val) {
      this.clear_modal_init();
    },
    plaintObject: function (val) {
      if (val !== undefined && val !== null) this.srediObjekat(val);
      else this.clear_modal_init();
    },
    item: function (val) {
      if (val !== undefined && val !== null) this.editItemSpray(val);
      else this.clear_modal_init();
    },
    edit: function (val) {},
    operacija_zastite: function (val) {
        if(val !== undefined){
          this.pomSuffix = "";
          let pom = val.split("|");

          if (pom[0] === "djubrenje") {
            this.naslov = "Izbor đubriva";

            this.grupaNaslov = "Grupa đubriva";
            this.naslovPreparat = "Đubrivo";
            this.naslovBolest = "Svrha đubrenja";

            if(pom[1] === "32")
              this.vidljivostKoncentracije = false;
            else
              this.vidljivostKoncentracije = true;
          } else {
            this.naslov = "Izbor preparata";

            this.grupaNaslov = "Grupa preparata";
            this.naslovPreparat = "Preparat";
            this.naslovBolest = "Bolest";

            this.vidljivostKoncentracije = true;
          }
        }
    },
  },
  mounted() {
    this.clear_modal_init();
    // this.setTime();
    // this.setDate();

    //this.clear_modal();

    // this.getAllJediniceMere();
  },
};
</script>

<style lang="scss" scoped>
.addingItemComponentForm {
  max-width: 430px;
}

.Description textarea {
  height: 40px !important;
}

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

@import "./../assets/sass/parts/modalStyles";

.coupageItemComponentForm {
  max-width: 430px;
}

.Description textarea {
  height: 40px;
}

#FloatingButton {
  position: absolute;
  width: 54px;
  height: 54px;
  font-size: 25px;
  border-radius: 50%;
  color: #ffffff;
  background-color: #018389;
  // transition: .2s ease-in-out;
  // p {
  //   position: relative;
  //   width: 100%;
  //   height: 100%;
  //   i {
  //     position: absolute;
  //     left: 6px;
  //     top: 6px;
  //     transform: rotate(45deg);
  //     color: #ffffff;
  //   }
  // }
  &:active,
  &:focus {
    box-shadow: none;
  }
}
</style>
